

import React from 'react';


import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg } from 'html-to-image';


import { opeResultsText } from './../../text/ope-results-text.js';
import { conResultsText } from './../../text/con-results-text.js';
import { extResultsText } from './../../text/ext-results-text.js';
import { agrResultsText } from './../../text/agr-results-text.js';
import { staResultsText } from './../../text/sta-results-text.js';
import { strengthsText } from './../../text/strengths-text.js';

import { overviewText } from './../../text/overview-text.js';

import ordinal from './../../util/ordinal-numbers.jsx';

import Logo from './../../images/logo.png';

import O from './../../images/ope.png';
import O2 from './../../images/clo.png';
import C from './../../images/conc.png';
import C2 from './../../images/unc.png';
import E from './../../images/ext.png';
import E2 from './../../images/int.png';
import A from './../../images/agr.png';
import A2 from './../../images/dis.png';
import S from './../../images/sta.png';
import S2 from './../../images/neu.png';

import OpeClo from './../../images/ope_clo.png';
import ConUnc from './../../images/con_unc.png';
import ExtInt from './../../images/ext_int.png';
import AgrDis from './../../images/agr_dis.png';
import EmoNeu from './../../images/emo_neu.png';


import OpeImage1 from './../../images/facet-images/open 1.svg';
import OpeImage2 from './../../images/facet-images/open 2.svg';
import OpeImage3 from './../../images/facet-images/open 3.svg';

import CloImage1 from './../../images/facet-images/clo-1.svg';
import CloImage2 from './../../images/facet-images/clo-2.svg';
import CloImage3 from './../../images/facet-images/clo-3.svg';

import ConImage1 from './../../images/facet-images/con-1.svg';
import ConImage2 from './../../images/facet-images/con-2.svg';
import ConImage3 from './../../images/facet-images/con-3.svg';

import UncImage1 from './../../images/facet-images/unc-1.svg';
import UncImage2 from './../../images/facet-images/unc-2.svg';
import UncImage3 from './../../images/facet-images/unc-3.svg';

import ExtImage1 from './../../images/facet-images/ext-1.svg';
import ExtImage2 from './../../images/facet-images/ext-2.svg';
import ExtImage3 from './../../images/facet-images/ext-3.svg';

import IntImage1 from './../../images/facet-images/int-1.svg';
import IntImage2 from './../../images/facet-images/int-2.svg';
import IntImage3 from './../../images/facet-images/int-3.svg';

import AgrImage1 from './../../images/facet-images/agr-1.svg';
import AgrImage2 from './../../images/facet-images/agr-2.svg';
import AgrImage3 from './../../images/facet-images/agr-3.svg';

import DisImage1 from './../../images/facet-images/dis-1.svg';
import DisImage2 from './../../images/facet-images/dis-2.svg';
import DisImage3 from './../../images/facet-images/dis-3.svg';

import EmoImage1 from './../../images/facet-images/emo-1.svg';
import EmoImage2 from './../../images/facet-images/emo-2.svg';
import EmoImage3 from './../../images/facet-images/emo-3.svg';

import NeuImage1 from './../../images/facet-images/neu-1.svg';
import NeuImage2 from './../../images/facet-images/neu-2.svg';
import NeuImage3 from './../../images/facet-images/neu-3.svg';



import ResultChart from './../../components/result-chart';
import ResultImage from './../../components/result-image';


import Spinner from './../../components/spinner';


import './../results.scss';
import './../pre-test.scss';
import './../../global-variables.scss';




import { motion } from 'framer-motion';


const opeImageText1 = "Unconventional thinker";
const opeImageText2 = "Seeks novelty";
const opeImageText3 = "Interested in aesthetics and ideas";

const cloImageText1 = "Follows convention";
const cloImageText2 = "Practical-minded";
const cloImageText3 = "Fixed interests";

const conImageText1 = "Punctual";
const conImageText2 = "Makes plans";
const conImageText3 = "Organised";

const uncImageText1 = "Misses deadlines";
const uncImageText2 = "Unorganised";
const uncImageText3 = "Sporadic";

const extImageText1 = "Fun-seeking";
const extImageText2 = "Exciteable";
const extImageText3 = "Large social networks";

const intImageText1 = "Seeks alone time";
const intImageText2 = "Quiet";
const intImageText3 = "Small social networks";

const agrImageText1 = "Soft-hearted";
const agrImageText2 = "Conflict-averse";
const agrImageText3 = "Generous";

const disImageText1 = "Blunt";
const disImageText2 = "Doesn't mind conflict";
const disImageText3 = "Competitive";

const staImageText1 = "Self-assured";
const staImageText2 = "Calm";
const staImageText3 = "Optimistic";

const neuImageText1 = "Moody";
const neuImageText2 = "Self-concious";
const neuImageText3 = "Wary";



const OverviewTab = ({ personalityData, isPaid }) => {


    let personalityDataExists = true;

    let scaleText;

    let opeTitle;
    let opeScale;
    let opeText1;
    let opeText2;
    let opeText3;

    let conTitle;
    let conScale;
    let conText1;
    let conText2;
    let conText3;

    let extTitle;
    let extScale;
    let extText1;
    let extText2;
    let extText3;

    let agrTitle;
    let agrScale;
    let agrText1;
    let agrText2;
    let agrText3;

    let staTitle;
    let staScale;
    let staText1;
    let staText2;
    let staText3;

    let opeAkaText = '';
    let conAkaText = '';
    let emoAkaText = '';

    let akaText = '';

    let showOpeStrengths = true;
    let showConStrengths = true;
    let showExtStrengths = true;
    let showAgrStrengths = true;
    let showStaStrengths = true;

    let opeImage1;
    let opeImage2;
    let opeImage3;

    let conImage1;
    let conImage2;
    let conImage3;

    let extImage1;
    let extImage2;
    let extImage3;

    let agrImage1;
    let agrImage2;
    let agrImage3;

    let staImage1;
    let staImage2;
    let staImage3;

    let facetOpeImageText1;
    let facetOpeImageText2;
    let facetOpeImageText3;

    let facetConImageText1;
    let facetConImageText2;
    let facetConImageText3;

    let facetExtImageText1;
    let facetExtImageText2;
    let facetExtImageText3;

    let facetAgrImageText1;
    let facetAgrImageText2;
    let facetAgrImageText3;

    let facetStaImageText1;
    let facetStaImageText2;
    let facetStaImageText3;


    if (personalityData == null) {
        personalityData = ({ "ope": 4, "con": 4, "ext": 4, "agr": 4, "sta": 4 });
        personalityDataExists = false;
    }

    const opeLevel = personalityData.ope;
    const conLevel = personalityData.con;
    const extLevel = personalityData.ext;
    const agrLevel = personalityData.agr;
    const staLevel = personalityData.sta;


    const opePercentile = personalityData.opePercentile;
    const conPercentile = personalityData.conPercentile;
    const extPercentile = personalityData.extPercentile;
    const agrPercentile = personalityData.agrPercentile;
    const staPercentile = personalityData.staPercentile;


    //console.log("opelevel=" + personalityData);

    //const opeLevel = 2; 
    //const conLevel = 2; 
    //const extLevel = 2; 
    //const agrLevel = 2;
    //const staLevel = 2; 

    const opeName = "Curious";
    const cloName = "Practical";
    const opeCloName = "Pragmatic";

    const conName = "Structured";
    const uncName = "Unstructured";
    const conUncName = "Balanced";

    const extName = "Extraverted";
    const intName = "Introverted";
    const extIntName = "Ambivert";

    const agrName = "Agreeable";
    const disName = "Disagreeable";
    const agrDisName = "Adaptable";

    const staName = "Emotionally stable";
    const neuName = "Sensitive";
    const staNeu = "Emotionally balanced";

    if (opeLevel <= 1) {
        opeTitle = "Highly practical";

        opeScale = `You are highly practical. This means that you are on the extreme end of the personality spectrum for this trait. It is a defining trait to you, meaning that you identify strongly with the aspects that are described. They affect your perceptions and desires strongly. You are likely to be one of the most practical people that you know.`;


    }
    else if (opeLevel <= 2) {
        opeTitle = "Moderately practical";

        opeScale = `You are moderately practical. This means that you identify with the personality aspects of this trait more than most other people. This trait has significance to you and defines many of your perceptions and desires. However, you are not on the extreme end of the personality spectrum, and you likely know some other people who are more practical than you. `;

    }
    else if (opeLevel <= 3) {
        opeTitle = "Somewhat practical";

        opeScale = `You are somewhat practical. This means that you somewhat identify with the personality aspects of this trait. You may identify with some of the personality descriptions from this trait, and some not so much. You likely know people who are more practical than you. `;

    }
    else if (opeLevel <= 4) {
        opeTitle = "Pragmatic";

        opeScale = "You are pragmatic. This means that you are in the middle of the personality spectrum for this trait, not identifying strongly with either side. You find that you identify with curious traits at times and practical traits at other times. You know people who are more curious than you and more practical than you. "


    }
    else if (opeLevel <= 5) {
        opeTitle = "Somewhat curious";

        opeScale = `You are somewhat curious. This means that you somewhat identify with the personality aspects of this trait. You may identify with some of the personality descriptions from this trait, and some not so much. You likely know people who are more curious than you. `;


    }
    else if (opeLevel <= 6) {
        opeTitle = "Moderately curious";


        opeScale = `You are moderately curious. This means that you identify with the personality aspects of this trait more than most other people. This trait has significance to you and defines many of your perceptions and desires. However, you are not on the extreme end of the personality spectrum, and you likely know some other people who are more curious than you. `;

    }
    else if (opeLevel <= 7) {
        opeTitle = "Highly curious";

        opeScale = `You are highly curious. This means that you are on the extreme end of the personality spectrum for this trait. It is a defining trait to you, meaning that you identify strongly with the aspects that are described. They affect your perceptions and desires strongly. You are likely to be one of the most curious people that you know.`;

    }


    if (conLevel <= 1) {
        conTitle = "Highly unstructured";

        conScale = `You are highly unstructured. This means that you are on the extreme end of the personality spectrum for this trait. It is a defining trait to you, meaning that you identify strongly with the aspects that are described. They affect your perceptions and desires strongly. You are likely to be one of the most unstructured people that you know.`;

    }
    else if (conLevel <= 2) {
        conTitle = "Moderately unstructured";

        conScale = `You are moderately unstructured. This means that you identify with the personality aspects of this trait more than most other people. This trait has significance to you and defines many of your perceptions and desires. However, you are not on the extreme end of the personality spectrum, and you likely know some other people who are more unstructured than you. `;

    }
    else if (conLevel <= 3) {
        conTitle = "Somewhat unstructured";

        conScale = `You are somewhat unstructured. This means that you somewhat identify with the personality aspects of this trait. You may identify with some of the personality descriptions from this trait, and some not so much. You likely know people who are more unstructured than you. `;

    }
    else if (conLevel <= 4) {
        conTitle = "Neither structured nor unstructured";

        conScale = "You are balanced. This means that you are in the middle of the personality spectrum for this trait, not identifying strongly with either side. You find that you identify with curious traits at times and practical traits at other times. You know people who are more structrued than you and more unstructured than you. ";


    }
    else if (conLevel <= 5) {
        conTitle = "Somewhat structured";


        conScale = `You are somewhat structured. This means that you somewhat identify with the personality aspects of this trait. You may identify with some of the personality descriptions from this trait, and some not so much. You likely know people who are more structured than you. `;

    }
    else if (conLevel <= 6) {
        conTitle = "Moderately structured";

        conScale = `You are moderately structured. This means that you identify with the personality aspects of this trait more than most other people. This trait has significance to you and defines many of your perceptions and desires. However, you are not on the extreme end of the personality spectrum, and you likely know some other people who are more structured than you. `;

    }
    else if (conLevel <= 7) {
        conTitle = "Highly structured";

        conScale = `You are highly structured. This means that you are on the extreme end of the personality spectrum for this trait. It is a defining trait to you, meaning that you identify strongly with the aspects that are described. They affect your perceptions and desires strongly. You are likely to be one of the most structured people that you know.`;

    }



    if (extLevel <= 1) {
        extTitle = "Highly introverted";

        extScale = `You are highly introverted. This means that you are on the extreme end of the personality spectrum for this trait. It is a defining trait to you, meaning that you identify strongly with the aspects that are described. They affect your perceptions and desires strongly. You are likely to be one of the most introverted people that you know.`;

    }
    else if (extLevel <= 2) {
        extTitle = "Moderately introverted";

        extScale = `You are moderately introverted. This means that you identify with the personality aspects of this trait more than most other people. This trait has significance to you and defines many of your perceptions and desires. However, you are not on the extreme end of the personality spectrum, and you likely know some other people who are more introverted than you. `;

    }
    else if (extLevel <= 3) {
        extTitle = "Somewhat introverted";


        extScale = `You are somewhat introverted. This means that you somewhat identify with the personality aspects of this trait. You may identify with some of the personality descriptions from this trait, and some not so much. You likely know people who are more introverted than you. `;

    }
    else if (extLevel <= 4) {
        extTitle = "Ambivert";

        extScale = "You are ambiverted. This means that you are in the middle of the personality spectrum for this trait, not identifying strongly with either side. You find that you identify with extraverted traits at times and introverted traits at other times. You know people who are more extraverted than you and more introverted than you. ";

    }
    else if (extLevel <= 5) {
        extTitle = "Somewhat extraverted";


        extScale = `You are somewhat extraverted. This means that you somewhat identify with the personality aspects of this trait. You may identify with some of the personality descriptions from this trait, and some not so much. You likely know people who are more extraverted than you. `;

    }
    else if (extLevel <= 6) {
        extTitle = "Moderately extraverted";

        extScale = `You are moderately extraverted. This means that you identify with the personality aspects of this trait more than most other people. This trait has significance to you and defines many of your perceptions and desires. However, you are not on the extreme end of the personality spectrum, and you likely know some other people who are more extraverted than you. `;

    }
    else if (extLevel <= 7) {
        extTitle = "Highly extraverted";

        extScale = `You are highly extraverted. This means that you are on the extreme end of the personality spectrum for this trait. It is a defining trait to you, meaning that you identify strongly with the aspects that are described. They affect your perceptions and desires strongly. You are likely to be one of the most extraverted people that you know.`;

    }




    if (agrLevel <= 1) {
        agrTitle = "Highly disagreeable";

        agrScale = `You are highly disagreeable. This means that you are on the extreme end of the personality spectrum for this trait. It is a defining trait to you, meaning that you identify strongly with the aspects that are described. They affect your perceptions and desires strongly. You are likely to be one of the most disagreeable people that you know.`;

    }
    else if (agrLevel <= 2) {
        agrTitle = "Moderately disagreeable";

        agrScale = `You are moderately disagreeable. This means that you identify with the personality aspects of this trait more than most other people. This trait has significance to you and defines many of your perceptions and desires. However, you are not on the extreme end of the personality spectrum, and you likely know some other people who are more disagreeable than you. `;

    }
    else if (agrLevel <= 3) {
        agrTitle = "Somewhat disagreeable";


        agrScale = `You are somewhat disagreeable. This means that you somewhat identify with the personality aspects of this trait. You may identify with some of the personality descriptions from this trait, and some not so much. You likely know people who are more disagreeable than you. `;

    }
    else if (agrLevel <= 4) {
        agrTitle = "Adaptable";

        agrScale = "You are adaptable. This means that you are in the middle of the personality spectrum for this trait, not identifying strongly with either side. You find that you identify with agreeable traits at times and disagreeable traits at other times. You know people who are more agreeable than you and more disagreeable than you. ";


    }
    else if (agrLevel <= 5) {
        agrTitle = "Somewhat agreeable";


        agrScale = `You are somewhat agreeable. This means that you somewhat identify with the personality aspects of this trait. You may identify with some of the personality descriptions from this trait, and some not so much. You likely know people who are more agreeable than you. `;

    }
    else if (agrLevel <= 6) {
        agrTitle = "Moderately agreeable";

        agrScale = `You are moderately agreeable. This means that you identify with the personality aspects of this trait more than most other people. This trait has significance to you and defines many of your perceptions and desires. However, you are not on the extreme end of the personality spectrum, and you likely know some other people who are more agreeable than you. `;

    }
    else if (agrLevel <= 7) {
        agrTitle = "Highly agreeable";

        agrScale = `You are highly agreeable. This means that you are on the extreme end of the personality spectrum for this trait. It is a defining trait to you, meaning that you identify strongly with the aspects that are described. They affect your perceptions and desires strongly. You are likely to be one of the most agreeable people that you know.`;

    }




    if (staLevel <= 1) {
        staTitle = "Highly sensitive";

        staScale = `You are highly sensitive. This means that you are on the extreme end of the personality spectrum for this trait. It is a defining trait to you, meaning that you identify strongly with the aspects that are described. They affect your perceptions and desires strongly. You are likely to be one of the most sensitive people that you know.`;

    }
    else if (staLevel <= 2) {
        staTitle = "Moderately sensitive";

        staScale = `You are moderately sensitive. This means that you identify with the personality aspects of this trait more than most other people. This trait has significance to you and defines many of your perceptions and desires. However, you are not on the extreme end of the personality spectrum, and you likely know some other people who are more sensitive than you. `;

    }
    else if (staLevel <= 3) {
        staTitle = "Somewhat sensitive";

        staScale = `You are somewhat sensitive. This means that you somewhat identify with the personality aspects of this trait. You may identify with some of the personality descriptions from this trait, and some not so much. You likely know people who are more sensitive than you. `;


    }
    else if (staLevel <= 4) {
        staTitle = "Emotionally balanced";


        staScale = "You are emotionally balanced. This means that you are in the middle of the personality spectrum for this trait, not identifying strongly with either side. You find that you identify with emotionally stable traits at times and sensitive traits at other times. You know people who are more emotionally stable than you and more sensitive than you. ";


    }
    else if (staLevel <= 5) {
        staTitle = "Somewhat emotionally stable";

        staScale = `You are somewhat emotionally stable. This means that you somewhat identify with the personality aspects of this trait. You may identify with some of the personality descriptions from this trait, and some not so much. You likely know people who are more emotionally stable than you. `;



    }
    else if (staLevel <= 6) {
        staTitle = "Moderately emotionally stable";

        staScale = `You are moderately emotionally stable. This means that you identify with the personality aspects of this trait more than most other people. This trait has significance to you and defines many of your perceptions and desires. However, you are not on the extreme end of the personality spectrum, and you likely know some other people who are more emotionally stable than you. `;


    }
    else if (staLevel <= 7) {
        staTitle = "Highly emotionally stable";

        staScale = `You are highly emotionally stable. This means that you are on the extreme end of the personality spectrum for this trait. It is a defining trait to you, meaning that you identify strongly with the aspects that are described. They affect your perceptions and desires strongly. You are likely to be one of the most emotionally stable people that you know.`;

    }


    if (opeLevel <= 4) {
        opeAkaText = 'Known academically as: Closed to experience';


        opeImage1 = CloImage1;
        opeImage2 = CloImage2;
        opeImage3 = CloImage3;

        facetOpeImageText1 = cloImageText1;
        facetOpeImageText2 = cloImageText2;
        facetOpeImageText3 = cloImageText3;

    }
    else {
        opeAkaText = 'Known academically as: Open to experience';


        opeImage1 = OpeImage1;
        opeImage2 = OpeImage2;
        opeImage3 = OpeImage3;

        facetOpeImageText1 = opeImageText1;
        facetOpeImageText2 = opeImageText2;
        facetOpeImageText3 = opeImageText3;


    }

    if (opeLevel == 4) {
        showOpeStrengths = false;

         conAkaText = 'Known academically as: Open / Closed to experience';
    }



    if (conLevel <= 4) {
        conAkaText = 'Known academically as: Unconscientious';

        conImage1 = UncImage1;
        conImage2 = UncImage2;
        conImage3 = UncImage3;

        facetConImageText1 = uncImageText1;
        facetConImageText2 = uncImageText2;
        facetConImageText3 = uncImageText3;

    }
    else {
        conAkaText = 'Known academically as: Conscientious';

        conImage1 = ConImage1;
        conImage2 = ConImage2;
        conImage3 = ConImage3;

        facetConImageText1 = conImageText1;
        facetConImageText2 = conImageText2;
        facetConImageText3 = conImageText3;
    }

    if (conLevel == 4) {
        showConStrengths = false;
        conAkaText = 'Known as: Conscientious / Unconscientious'
    }


    if (extLevel <= 4) {

        extImage1 = IntImage1;
        extImage2 = IntImage2;
        extImage3 = IntImage3;

        facetExtImageText1 = intImageText1;
        facetExtImageText2 = intImageText2;
        facetExtImageText3 = intImageText3;
    }
    else {

        extImage1 = ExtImage1;
        extImage2 = ExtImage2;
        extImage3 = ExtImage3;

        facetExtImageText1 = extImageText1;
        facetExtImageText2 = extImageText2;
        facetExtImageText3 = extImageText3;
    }

    if (extLevel == 4) {
        showExtStrengths = false;
    }


    if (agrLevel <= 4) {

        agrImage1 = DisImage1;
        agrImage2 = DisImage2;
        agrImage3 = DisImage3;

        facetAgrImageText1 = disImageText1;
        facetAgrImageText2 = disImageText2;
        facetAgrImageText3 = disImageText3;
    }
    else {

        agrImage1 = AgrImage1;
        agrImage2 = AgrImage2;
        agrImage3 = AgrImage3;

        facetAgrImageText1 = agrImageText1;
        facetAgrImageText2 = agrImageText2;
        facetAgrImageText3 = agrImageText3;
    }


    if (agrLevel == 4) {
        showAgrStrengths = false;
    }

    if (staLevel <= 4) {
        emoAkaText = 'Known academically as: Neurotic';

        staImage1 = NeuImage1;
        staImage2 = NeuImage2;
        staImage3 = NeuImage3;

        facetStaImageText1 = neuImageText1;
        facetStaImageText2 = neuImageText2;
        facetStaImageText3 = neuImageText3;

    }
    else {
        staImage1 = EmoImage1;
        staImage2 = EmoImage2;
        staImage3 = EmoImage3;

        facetStaImageText1 = staImageText1;
        facetStaImageText2 = staImageText2;
        facetStaImageText3 = staImageText3;

    }

    if (staLevel == 4) {
        emoAkaText = 'Known academically as: Emotionally stable / Neurotic'
        showStaStrengths = false;
    }


    let opeLogo;
    let conLogo;
    let extLogo;
    let agrLogo;
    let staLogo;




    // setting correct logos and text

    if (opeLevel < 4) {
        opeLogo = O2;

        opeText1 = overviewText.cloText1;
        opeText2 = overviewText.cloText2;
        opeText3 = overviewText.cloText3;

    }
    else if (opeLevel > 4) {
        opeLogo = O;

        opeText1 = overviewText.opeText1;
        opeText2 = overviewText.opeText2;
        opeText3 = overviewText.opeText3;

    }
    else {
        opeLogo = OpeClo;

        opeText1 = overviewText.opeCloText1;
        opeText2 = overviewText.opeCloText2;

    }

    if (conLevel < 4) {
        conLogo = C2;

        conText1 = overviewText.uncText1;
        conText2 = overviewText.uncText2;
        conText3 = overviewText.uncText3;

    }
    else if (conLevel > 4) {
        conLogo = C;

        conText1 = overviewText.conText1;
        conText2 = overviewText.conText2;
        conText3 = overviewText.conText3;

    }
    else {
        conLogo = ConUnc;

        conText1 = overviewText.conUncText1;
        conText2 = overviewText.conUncText2;

    }

    if (extLevel < 4) {
        extLogo = E2;

        extText1 = overviewText.intText1;
        extText2 = overviewText.intText2;
        extText3 = overviewText.intText3;

    }
    else if (extLevel > 4) {
        extLogo = E;

        extText1 = overviewText.extText1;
        extText2 = overviewText.extText2;
        extText3 = overviewText.extText3;


    }
    else {
        extLogo = ExtInt;

        extText1 = overviewText.extIntText1;
        extText2 = overviewText.extIntText2;

    }

    if (agrLevel < 4) {
        agrLogo = A2;


        agrText1 = overviewText.disText1;
        agrText2 = overviewText.disText2;
        agrText3 = overviewText.disText3;

    }
    else if (agrLevel > 4) {
        agrLogo = A;

        agrText1 = overviewText.agrText1;
        agrText2 = overviewText.agrText2;
        agrText3 = overviewText.agrText3;

    }
    else {
        agrLogo = AgrDis;

        agrText1 = overviewText.agrDisText1;
        agrText2 = overviewText.agrDisText2;

    }

    if (staLevel < 4) {
        staLogo = S2;

        staText1 = overviewText.neuText1;
        staText2 = overviewText.neuText2;
        staText3 = overviewText.neuText3;

    }
    else if (staLevel > 4) {
        staLogo = S;

        staText1 = overviewText.staText1;
        staText2 = overviewText.staText2;
        staText3 = overviewText.staText3;

    }
    else {
        staLogo = EmoNeu;

        staText1 = overviewText.staNeuText1;
        staText2 = overviewText.staNeuText2;



    }



    const Facet = ({ facetTitle, facetLogo, scaleText, facetText1, facetText2, facetText3, showFacetIcons, akaText, level, facetType, facetImage1, facetImage2, facetImage3, imageText1, imageText2, imageText3,
        trait, percentile, isPaid }) => {

        return (

            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1, transition: { delay: 0.3 } }}
                viewport={{ once: true }}
            >
                <div className="facet">
                    <h1 className="facet-title" >
                        <img className="facet-title-logo" src={facetLogo} alt="logo" />
                        <div>
                            {facetTitle}

                            {isPaid ?
                                <span> -  {percentile}{ordinal(percentile)} Percentile </span>
                                : <></>
                            }
                        </div>
                    </h1>

                    <div className="subheading"> {akaText}</div>
                    <div className="facet-result-chart">
                        <ResultChart facetType={facetType} level={level} />
                    </div>

                    {showFacetIcons == true ?

                        <div className="facet-images">
                            < ResultImage image={facetImage1} text={imageText1} />
                            < ResultImage image={facetImage2} text={imageText2} />
                            < ResultImage image={facetImage3} text={imageText3} />

                        </div>

                        : <></>

                    }


                    {scaleText}


                    <div className="small-vertical-spacer" />



                    {facetText1}

                    <div className="small-vertical-spacer" />
                    {facetText2}

                    <div className="small-vertical-spacer" />
                    <div>
                        {facetText3}
                    </div>

                </div>

            </motion.div>

        );

    }



    return (
        <>
            <Facet facetTitle={opeTitle} facetLogo={opeLogo} scaleText={opeScale} facetText1={opeText1} facetText2={opeText2} facetText3={opeText3}
                showFacetIcons={showOpeStrengths}
                akaText={opeAkaText} level={opeLevel - 1} facetType={"ope"} facetImage1={opeImage1} facetImage2={opeImage2} facetImage3={opeImage3}
                imageText1={facetOpeImageText1} imageText2={facetOpeImageText2} imageText3={facetOpeImageText3} isPaid={isPaid}

                percentile={opePercentile}

                trait={"o"}
            />

            <hr />

            <Facet facetTitle={conTitle} facetLogo={conLogo} scaleText={conScale} facetText1={conText1} facetText2={conText2} facetText3={conText3}

                akaText={conAkaText} level={conLevel - 1} facetType={"con"} facetImage1={conImage1} facetImage2={conImage2} facetImage3={conImage3}
                imageText1={facetConImageText1} imageText2={facetConImageText2} imageText3={facetConImageText3} isPaid={isPaid}

                percentile={conPercentile}

                trait={"c"}
            />

            <hr />


            <Facet facetTitle={extTitle} facetLogo={extLogo} scaleText={extScale} facetText1={extText1} facetText2={extText2} facetText3={extText3}
                showFacetIcons={showExtStrengths}
                akaText={akaText} level={extLevel - 1} facetType={"ext"} facetImage1={extImage1} facetImage2={extImage2} facetImage3={extImage3}
                imageText1={facetExtImageText1} imageText2={facetExtImageText2} imageText3={facetExtImageText3} isPaid={isPaid}

                percentile={extPercentile}

                trait={"e"}
            />

            <hr />

            <Facet facetTitle={agrTitle} facetLogo={agrLogo} scaleText={agrScale} facetText1={agrText1} facetText2={agrText2} facetText3={agrText3}
                showFacetIcons={showAgrStrengths}
                akaText={akaText} level={agrLevel - 1} facetType={"agr"} facetImage1={agrImage1} facetImage2={agrImage2} facetImage3={agrImage3}
                imageText1={facetAgrImageText1} imageText2={facetAgrImageText2} imageText3={facetAgrImageText3} isPaid={isPaid}

                percentile={agrPercentile}

                trait={"a"}
            />

            <hr />

            <Facet facetTitle={staTitle} facetLogo={staLogo} scaleText={staScale} facetText1={staText1} facetText2={staText2} facetText3={staText3}
                showFacetIcons={showStaStrengths}
                akaText={emoAkaText} level={staLevel - 1} facetType={"sta"} facetImage1={staImage1} facetImage2={staImage2} facetImage3={staImage3}
                imageText1={facetStaImageText1} imageText2={facetStaImageText2} imageText3={facetStaImageText3} isPaid={isPaid}

                percentile={staPercentile}

                trait={"s"}
            />

        </>

    );






}

export default OverviewTab;